function consoleMessage(...args) {
    queueMicrotask(console.log.bind(console, ...args));
}

console.message = consoleMessage
